import { message } from "antd";
import { useEffect, useState } from "react";

export const useSelectedItems = ({ item, onChangeShareInfo, t, onDelete, conf }) => {
  const [visible, setVisible] = useState(false);
  const [deletedBeforeSave, setDeletedBeforeSave] = useState([]);
  const disabled = item.isOwnData ? !!item.disabled : item.status === 'rejected' || item.status === 'deleted';
  const name = ((item.status || []).includes('approved') || item.isOwnData) ? (item.data?.name || '') : '--';

  useEffect(() => {
    setVisible(false);
  }, [item]);

  const renderDatastakeId = () => {
    if ((item.status || []).includes('approved')) {
      return item.data?.userId || '';
    }

    if (item.emailOrDSID === 'datastakeId') {
      return item.data?.userId || '';
    }

    return '--';
  };

  const renderName = () => {
    if (item.isOwnData) {
      return t('Own Data');
    }

    if (item.data && conf) {
      return t(conf.group === 'dataClient' ? 'Information Client' : 'Information Source');
    }

    return '';
  };

  const email = (item.emailOrDSID === 'email' || item.isOwnData) ? item.data?.email || '' : '--';

  const onChangeSelect = (checked, value) => {
    if (checked) {
      onChangeShareInfo([...(item.shareInfo || []), value]);
    } else {
      onChangeShareInfo([...(item.shareInfo || []).filter((v) => v !== value)]);
    }
  };

  const onDeleteClick = () => {
    setDeletedBeforeSave((prev) => [...prev, item?.data?.id]);
    onDelete();
    setVisible(false);
  };

  return {
    email,
    visible,
    name,
    disabled,
    setVisible,
    renderName,
    onChangeSelect,
    renderDatastakeId,
    onDeleteClick,
    deletedBeforeSave,
  };
}
